import React, { useState } from "react";
import { motion } from "framer-motion";
import { chartColors, greyScale, DEFAULT_ACCENT } from "@/styles/colors";

const PRESET_COLORS = [
  chartColors.red,
  chartColors.orange,
  chartColors.yellow,
  chartColors.green,
  chartColors.teal,
  chartColors.blue,
  DEFAULT_ACCENT, // Indigo
  chartColors.violet,
  chartColors.pink,
  greyScale[600], // Gray
];

interface ColorPickerProps {
  value?: string;
  onChange: (color: string) => void;
  label?: string;
  compact?: boolean;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
  label,
  compact = false,
}) => {
  const [customColor, setCustomColor] = useState(value || DEFAULT_ACCENT);

  return (
    <div className={`color-picker ${compact ? "space-y-2" : "space-y-3"}`}>
      {label && (
        <label className="block text-sm font-medium text-white/80 mb-2">
          {label}
        </label>
      )}

      {/* Preset colors */}
      <div className={`flex flex-wrap ${compact ? "gap-1.5" : "gap-2"}`}>
        {PRESET_COLORS.map((color) => (
          <motion.button
            key={color}
            whileHover={{ scale: 1.15 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onChange(color)}
            className={`rounded-full border-2 transition-all ${
              compact ? "w-6 h-6" : "w-8 h-8"
            } ${
              value === color
                ? "border-white ring-2 ring-offset-2 ring-offset-gray-800 ring-white/50"
                : "border-transparent hover:border-white/50"
            }`}
            style={{ backgroundColor: color }}
            title={color}
          />
        ))}
      </div>

      {/* Custom color picker */}
      {!compact && (
        <div className="flex items-center gap-2">
          <input
            type="color"
            value={customColor.startsWith("#") ? customColor : "#6366F1"}
            onChange={(e) => {
              setCustomColor(e.target.value);
              onChange(e.target.value);
            }}
            className="w-8 h-8 rounded cursor-pointer border-0 bg-transparent"
          />
          <span className="text-sm text-white/60">
            {customColor}
          </span>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;








